import { gql } from 'graphql-request';

export type AdminSite = {
    id: string;
    name: string;
    status: 'DRAFT' | 'ACTIVE' | 'ARCHIVED';
    activity: { isicDetail: { code: string; description: string } } | null;
    geography: { countryName: string; environment: string; geometryType: string } | null;
};

export type AdminSitesResult = {
    organisation: {
        sites: {
            items: AdminSite[];
            pagination: {
                page: number;
                pageSize: number;
                totalItems: number;
                totalPages: number;
                hasNext: boolean;
                hasPrevious: boolean;
            };
        };
    };
};

export type GqlSiteSortField =
    | 'NAME'
    | 'CREATED_AT'
    | 'VALID_FROM'
    | 'PHYSICAL_NATURE_RISK'
    | 'OPERATIONAL_DEPENDENCIES'
    | 'IMPACTS_ON_NATURE'
    | 'STATE_OF_NATURE'
    | 'ASSESSMENT_DATE'
    | 'COUNTRY'
    | 'ACTIVITY'
    | 'ENVIRONMENT'
    | 'GEOMETRY_TYPE';

export type GqlSortDirection = 'ASC' | 'DESC';

export const adminSitesQuery = gql`
    query AdminSites(
        $businessCentralId: String!
        $status: GqlSiteStatus!
        $page: Int!
        $pageSize: Int!
        $sortBy: GqlSiteSortField
        $sortDir: GqlSortDirection
        $nameContains: String
    ) {
        organisation(businessCentralId: $businessCentralId) {
            sites(status: $status, page: $page, pageSize: $pageSize, sortBy: $sortBy, sortDir: $sortDir, nameContains: $nameContains) {
                items {
                    id
                    name
                    status
                    activity {
                        isicDetail {
                            code
                            description
                        }
                    }
                    geography {
                        countryName
                        environment
                        geometryType
                    }
                }
                pagination {
                    page
                    pageSize
                    totalItems
                    totalPages
                    hasNext
                    hasPrevious
                }
            }
        }
    }
`;
